import { useState } from 'react';

import { DialogType } from '../../admin/AdminEventUsers/useAdminEventUsers';
import { User } from '../../apollo/__generated__/graphql';
import { useStaffCancelTransactionMutation } from '../../transactions/hooks/useStaffCancelTransactionMutation';
import { useCurrentUserQuery } from '../../user/hooks/useCurrentUserQuery';
import { useCurrentEventQuery } from './useCurrentEventQuery';

interface PaymentDialogInformation {
  userId: string;
  eventId: string;
}

export const useUpdatePayment = (
  setDialog: (dialog: DialogType | null) => void,
) => {
  const { data: currentUserData } = useCurrentUserQuery();
  const { data: currentEventData } = useCurrentEventQuery();
  const { cancelTransaction } = useStaffCancelTransactionMutation();
  const [paymentDialogInformation, setPaymentDialogInformation] =
    useState<PaymentDialogInformation | null>(null);

  const onPaymentPress = (user: User) => {
    if (!currentUserData?.currentUser?.isAdmin) {
      setDialog({
        title: 'Contactez un admin',
        description: `Valider un paiement nécessite des droits d'administrateur. Contactez un administrateur pour effectuer cette action.`,
        onSubmit: () => {
          setDialog(null);
        },
      });
      return;
    }
    const eventId = currentEventData?.currentEvent?.id ?? null;
    if (!eventId) {
      return;
    }
    if (user.hasPaidTicket) {
      setDialog({
        title: 'Annuler/Rembourser le paiement',
        description: `Êtes-vous sûr de vouloir rembourser (si le paiement était fait avec HelloAsso) ou annuler (si le paiement était validé manuellement) le paiment de ${user.firstname} ${user.lastname} ?`,
        onSubmit: () => {
          cancelTransaction({ userId: user.id, eventId });
          setDialog(null);
        },
      });
    } else {
      setPaymentDialogInformation({
        userId: user.id,
        eventId,
      });
    }
  };

  const onClosePaymentDialog = () => {
    setPaymentDialogInformation(null);
  };

  return { onPaymentPress, paymentDialogInformation, onClosePaymentDialog };
};
